var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pageSetup != null)?_c('div',{staticClass:"actions-page"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"section-title"},[_c('h1',[_vm._v(_vm._s(_vm.pageSetup.page_title))])]),_c('actionsItems')],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }